<template>
  <mdb-row class="d-flex justify-content-around mb-4">
    <mdb-btn title="Open Excel import dialog" size="sm" gradient="aqua" @click.native="excel.show = true">Import from Excel</mdb-btn>
    <mdb-btn title="Open network import dialog" disabled size="sm" gradient="aqua" @click.native="network.show = true">Import from Network</mdb-btn>
    <mdb-modal :show="network.show" @close="network.show = false">
      <mdb-modal-header class="text-center">
        <mdb-modal-title tag="h4" bold class="w-100">Import Rates from Network</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <select
          class="browser-default custom-select w-auto mt-3 mb-2"
          v-model="network.agent"
        >
          <option
            selected
            :value="null"
          >Select Agent
          </option>
          <option
            v-for="(agentName, key) in agents"
            :key="key"
            :value="agentName"
          >
            {{ agentName }}
          </option>
        </select>
        <mdb-input
          type="text"
          label="Host"
          v-model="network.host"
        />
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn title="Import" @click.native="submitNetwork()">Import</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <mdb-modal :show="excel.show" @close="excel.show = false" size="fluid">
      <mdb-modal-header class="text-center">
        <mdb-modal-title tag="h4" bold class="w-100">Import Rates from Excel</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <select
          class="browser-default custom-select w-auto mt-3 mb-2"
          v-model="excel.agent"
        >
          <option
            selected
            :value="null"
          >Select Agent
          </option>
          <option
            v-for="(agentName, key) in agents"
            :key="key"
            :value="agentName"
          >
            {{ agentName }}
          </option>
        </select>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="excel-import-addon">Excel file:</span>
          </div>
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              id="excel-import-file-input"
              @change="processFile($event)"
            />
            <label
              class="custom-file-label"
              for="excel-import-file-input"
            >
              {{ excel.file && (excel.file.name || '...no filename data...') || 'Choose file' }}
            </label>
          </div>
        </div>
        <mdb-row>
          <mdb-col col="4" class="pt-3">
            <h4>Include</h4>
            <mdb-row
              v-for="(incl, key) in excel.include"
              :key="key"
            >
              <mdb-col col="8">
                <select
                  class="d-inline browser-default custom-select w-auto mt-0"
                  v-model="excel.include[key].type"
                >
                  <option
                    selected
                    :value="null"
                  >Select Type
                  </option>
                  <option
                    v-for="(typeName, key) in surchargeTypes"
                    :key="key"
                    :value="typeName"
                  >
                    {{ typeName }}
                  </option>
                </select>
              </mdb-col>
              <mdb-col col="4">
                <mdb-btn
                  outline="warning"
                  size="sm"
                  icon="times"
                  class="d-inline mt-1"
                  @click.native.prevent="removeInclude(key)"
                  title="Remove included rate"
                />
              </mdb-col>
            </mdb-row>
            <mdb-btn
              outline="default"
              size="sm"
              icon="plus"
              @click.native.prevent="addInclude()"
              title="Add included rate"
            />
          </mdb-col>
          <mdb-col col="8" class="pt-3 border-left">
            <h4>Extra</h4>
            <mdb-row
              v-for="(extra, key) in excel.extra"
              :key="key"
            >
              <mdb-col>
                <select
                  class="d-inline browser-default custom-select w-auto mt-0"
                  v-model="excel.extra[key].type"
                >
                  <option
                    selected
                    :value="null"
                  >Select Type
                  </option>
                  <option
                    v-for="(typeName, key) in surchargeTypes"
                    :key="key"
                    :value="typeName"
                  >
                    {{ typeName }}
                  </option>
                </select>
              </mdb-col>
              <mdb-col>
                <select
                  class="d-inline browser-default custom-select w-auto mt-0"
                  v-model="excel.extra[key].measureUnit"
                >
                  <option
                    selected
                    :value="null"
                  >Select Measure Unit
                  </option>
                  <option
                    v-for="(typeName, key) in measureUnits"
                    :key="key"
                    :value="typeName"
                  >
                    {{ typeName }}
                  </option>
                </select>
              </mdb-col>
              <mdb-col>
                <mdb-input
                  type="number"
                  size="sm"
                  class="m-0"
                  label="Min. price"
                  v-model="excel.extra[key].minprice"
                />
              </mdb-col>
              <mdb-col>
                <mdb-input
                  type="number"
                  size="sm"
                  class="m-0"
                  label="Price"
                  v-model="excel.extra[key].price"
                />
              </mdb-col>
              <mdb-col>
                <mdb-btn
                  outline="warning"
                  size="sm"
                  icon="times"
                  class="d-inline mt-1"
                  @click.native.prevent="removeExtra(key)"
                  title="Remove extra rate"
                />
              </mdb-col>
            </mdb-row>
            <mdb-btn
              title="Add extra rate"
              icon="plus"
              outline="default"
              size="sm"
              @click.native.prevent="addExtra()"
            />
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn title="Import" @click.native="submitExcel()">Import</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </mdb-row>
</template>

<script>
import {
  mdbInput,
  mdbRow,
  mdbCol,
  mdbAlert,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbModalTitle
} from 'mdbvue'
import {mapState, mapMutations, mapActions} from 'vuex'
import {errorCatch} from '../utils'

class Include {
  constructor () {
    this.type = null
  }

  validate () {
    return typeof (this.type) === 'string'
  }
}
class Extra {
  constructor () {
    this.type = null
    this.measureUnit = null
    this.minprice = null
    this.price = null
  }

  validate () {
    return (
      typeof (this.type) === 'string' &&
      typeof (this.measureUnit) === 'string' &&
      (this.minprice === null || typeof parseFloat(this.price) === 'number') &&
      (this.price === null || typeof parseFloat(this.price) === 'number')
    )
  }
}

export default {
  name: 'Import',
  data: function () {
    return {
      excel: {
        show: false,
        agent: null,
        file: null,
        include: [],
        extra: []
      },
      network: {
        show: false,
        agent: null,
        host: null
      }
    }
  },
  computed: {
    ...mapState('admin', {
      agents: state => state.data.clients,
      surchargeTypes: state => state.data.surchargeTypes,
      measureUnits: state => state.data.measureUnits
    })
  },
  methods: {
    ...mapMutations(['ADD_ALERT']),
    ...mapActions('admin', ['fetch', 'importExcel', 'importNetwork']),
    addInclude () {
      this.excel.include.push(new Include())
    },
    removeInclude (key) {
      this.$delete(this.excel.include, key)
    },
    addExtra () {
      this.excel.extra.push(new Extra())
    },
    removeExtra (key) {
      this.$delete(this.excel.extra, key)
    },
    processFile (event) {
      this.$set(this.excel, 'file', event.target.files[0])
    },
    submitNetwork () {
      this.importNetwork({
        agent: this.network.agent,
        host: this.network.host
      })
    },
    submitExcel () {
      let valid = true

      valid = valid && typeof this.excel.agent === 'string'
      valid = valid && typeof this.excel.file === 'object' && this.excel.file instanceof File
      valid = valid && this.excel.include.every(el => el.validate())
      valid = valid && this.excel.extra.every(el => el.validate())

      if (!valid) {
        this.$notify.warn({
          title: 'Data validation failed.',
          message: null,
          position: 'top right',
          timeOut: 10000,
          closeButton: true
        })
        return
      }

      let formData = new FormData()
      formData.set('file', this.excel.file, this.excel.file.name)
      formData.set('agent', this.excel.agent)
      formData.set('include', JSON.stringify(this.excel.include))
      formData.set('extra', JSON.stringify(this.excel.extra))

      this.importExcel(formData)
        .then(response => {
          this.$set(this.excel, 'show', false)
          this.$notify.success({
            title: 'Validation successful.',
            message: response.data,
            position: 'top right',
            timeOut: 5000,
            closeButton: true
          })
        })
        .catch(error => {
          this.$notify.warn({
            title: 'Something wrong',
            message: error.response.data,
            position: 'top right',
            timeOut: 60000,
            closeButton: true
          })
        })
    }
  },
  mounted () {
    this.fetch('clients').catch(errorCatch('Fetch Agents', this))
    this.fetch('surchargeTypes').catch(errorCatch('Fetch Surcharge Types', this))
    this.fetch('measureUnits').catch(errorCatch('Fetch Measure Unit Names', this))
  },
  components: {
    mdbInput,
    mdbRow,
    mdbCol,
    mdbAlert,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalTitle
  }
}
</script>

<style scoped>
  .multi-line {
    white-space: pre;
  }
</style>



// WEBPACK FOOTER //
// src/components/Import.vue